import React from 'react'
import Orientation from 'react-native-orientation-locker';

export default class MobileLandscape extends React.Component {

	componentDidMount(){
		Orientation.lockToLandscape();
	}

	componentWillUnmount(){
		Orientation.lockToPortrait();
	}
	render(){
		return null
	}
}